import {HttpContext, HttpContextToken} from '@angular/common/http';
import {API_CONFIG} from '../api/api.config';

export const SILENT_HTTP_REQUEST = new HttpContextToken<boolean>(() => false);

export function silentHttp() {
  return {
    context: new HttpContext().set(SILENT_HTTP_REQUEST, true),
  };
}

function normalizeBaseUrl(url: string): string {
  return url.replace(/\/+$/, '');
}

function toAbsoluteUrl(url: string): string {
  try {
    return new URL(url, window.location.origin).toString();
  } catch {
    return url;
  }
}

export function isHoomvipApiRequest(url: string): boolean {
  const absoluteUrl = normalizeBaseUrl(toAbsoluteUrl(url));
  const baseUrl = API_CONFIG.apiBaseUrl;

  if (typeof baseUrl !== 'string' || baseUrl.trim() === '') {
    return false;
  }

  const normalizedBaseUrl = normalizeBaseUrl(toAbsoluteUrl(baseUrl));
  return absoluteUrl === normalizedBaseUrl || absoluteUrl.startsWith(`${normalizedBaseUrl}/`);
}
